export const SET_ORDER_ITEM = "SET_ORDER_ITEM";

export const setOrderItem = orderItem => ({
  type: SET_ORDER_ITEM,
  orderItem: orderItem
});
